import { action } from 'typesafe-actions';
import {
  Options,
  AreaOfInterestActionTypes,
  UploadNewAoiRequestPlayload,
  InitialAoiResponse,
  AoiClippedObject,
  AoiListPayload,
  AoiListResponse
} from 'types';

export const uploadShapeFileStart = (payload: UploadNewAoiRequestPlayload) =>
  action(AreaOfInterestActionTypes.UPLOAD_SHAPE_FILE_START, payload);

export const uploadShapeFileSuccess = (payload: any) =>
  action(AreaOfInterestActionTypes.UPLOAD_SHAPE_FILE_SUCCESS, payload);

export const uploadShapeFileFailure = (payload: string) =>
  action(AreaOfInterestActionTypes.UPLOAD_SHAPE_FILE_FAILURE, payload);

export const cancelUploadShapeFile = () =>
  action(AreaOfInterestActionTypes.CANCEL_UPLOAD_SHAPE_FILE);

export const putNewAOIStart = (payload: any) =>
  action(AreaOfInterestActionTypes.PUT_NEW_AOI_START, payload);

export const putNewAOISuccess = (payload: any) =>
  action(AreaOfInterestActionTypes.PUT_NEW_AOI_SUCCESS, payload);

export const putNewAOIFailure = (payload: string) =>
  action(AreaOfInterestActionTypes.PUT_NEW_AOI_FAILURE, payload);

export const revertUploadNewAOI = () =>
  action(AreaOfInterestActionTypes.REVERT_NEW_AOI);

export const updateGeoJsonFromMap = (payload: GeoJSON.GeometryObject) =>
  action(AreaOfInterestActionTypes.UPDATE_GEOJSON_FROM_MAP, payload);

export const updateGeoJsonFromBoundary = (payload: GeoJSON.GeometryObject) =>
  action(AreaOfInterestActionTypes.UPDATE_GEOJSON_FROM_BOUNDARY, payload);

export const getAOIListStart = (payload: AoiListPayload) =>
  action(AreaOfInterestActionTypes.GET_AOI_LIST_START, payload);

export const getAOIListSuccess = (payload: AoiListResponse) =>
  action(AreaOfInterestActionTypes.GET_AOI_LIST_SUCCESS, payload);

export const getAOIListFailure = (payload: string) =>
  action(AreaOfInterestActionTypes.GET_AOI_LIST_FAILURE, payload);

export const getCurrentAOIInfoStart = (payload: any) =>
  action(AreaOfInterestActionTypes.GET_CURRENT_AOI_INFO_START, payload);

export const getCurrentAOIInfoSuccess = (payload: any) =>
  action(AreaOfInterestActionTypes.GET_CURRENT_AOI_INFO_SUCCESS, payload);

export const getCurrentAOIInfoFailure = (payload: string) =>
  action(AreaOfInterestActionTypes.GET_CURRENT_AOI_INFO_FAILURE, payload);

export const getPreviewAOIInfoStart = (payload: any) =>
  action(AreaOfInterestActionTypes.GET_PREVIEW_AOI_INFO_START, payload);

export const getPreviewAOIInfoSuccess = (payload: any) =>
  action(AreaOfInterestActionTypes.GET_PREVIEW_AOI_INFO_SUCCESS, payload);

export const getPreviewAOIInfoFailure = (payload: string) =>
  action(AreaOfInterestActionTypes.GET_PREVIEW_AOI_INFO_FAILURE, payload);

export const setClippedObject = (payload: AoiClippedObject) =>
  action(AreaOfInterestActionTypes.SET_AOI_CLIPPED_OBJECT, payload);

export const setPreviewId = (payload: any) =>
  action(AreaOfInterestActionTypes.SET_AOI_PREVIEW_ID, payload);

export const unloadAOIPage = () =>
  action(AreaOfInterestActionTypes.UNLOAD_AOI_PAGE);

export const getLGABoundariesOptionStart = (payload: string[]) =>
  action(AreaOfInterestActionTypes.GET_LGA_BOUNDARIES_OPTION_START, payload);

export const getLGABoundariesOptionSuccess = (payload: Options) =>
  action(AreaOfInterestActionTypes.GET_LGA_BOUNDARIES_OPTION_SUCCESS, payload);

export const getLGABoundariesOptionFailure = (payload: string) =>
  action(AreaOfInterestActionTypes.GET_LGA_BOUNDARIES_OPTION_FAILURE, payload);

export const getLGABoundaryStart = (payload: string) =>
  action(AreaOfInterestActionTypes.GET_LGA_BOUNDARY_START, payload);

export const getLGABoundarySuccess = (payload: any) =>
  action(AreaOfInterestActionTypes.GET_LGA_BOUNDARY_SUCCESS, payload);

export const getLGABoundaryFailure = (payload: string) =>
  action(AreaOfInterestActionTypes.GET_LGA_BOUNDARY_FAILURE, payload);

export const initialAOIPageStart = (payload: string) =>
  action(AreaOfInterestActionTypes.INTIAL_AOI_PAGE_START, payload);

export const initialAOIPageSuccess = (payload: InitialAoiResponse) =>
  action(AreaOfInterestActionTypes.INTIAL_AOI_PAGE_SUCCESS, payload);

export const initialAOIPageFailure = (payload: string) =>
  action(AreaOfInterestActionTypes.INTIAL_AOI_PAGE_FAILURE, payload);

export const setLastVisitListPage = (page: number) =>
  action(AreaOfInterestActionTypes.SET_LAST_VISIT_LIST_PAGE, page);
